<p-panel styleClass="panel-shadow" class="driver-notes" [style]="{ 'margin-bottom': '1em' }">
  <p-header>
    <div class="panel-header">Release Code</div>
  </p-header>
  <div class="flex flex-wrap align-items-center" [class.ghost]="!releaseCodeTask">
    <div
      class="flex-grow-1 grid-label-value"
      *ngIf="releaseCodeTask?.releaseCode?.length > 1; else noCode"
    >
      <div class="white-space-nowrap">Release Code:</div>
      <div class="ghost-fill value">{{ releaseCodeTask?.releaseCode }}</div>
    </div>

    <ng-template #noCode>
      <div class="flex-grow-1" style="color: #999; font-weight: 500">No Code Provided</div>
    </ng-template>

    <div class="flex-shrink-1">
      <div *ngIf="organisationTypeId == 1 || organisationTypeId == 2">
        <button
          pButton
          label="Change"
          class="ui-button ui-button-secondary"
          (click)="showReleaseCodeDialog()"
        ></button>
      </div>
    </div>
  </div>
</p-panel>

<p-dialog
  header="Release Code"
  [(visible)]="isShownReleaseCode"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '350px' }"
>
  <div class="style2023 p-3">
    <div class="input-group">
      <div class="input-group-prepend">Code</div>
      <div class="input-group-item">
        <input [(ngModel)]="releaseCode" style="width: 100%" pInputText />
      </div>
    </div>
  </div>

  <p-footer class="rounded-bottom-border">
    <div class="text-right">
      <button
        type="button"
        pButton
        label="Close"
        class="ui-button ui-button-tertiary mr-2"
        (click)="isShownReleaseCode = false"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        (click)="saveReleaseCode()"
      ></button>
    </div>
  </p-footer>
</p-dialog>
